import { CycloneDXVersion, SPDXVersion } from '../../shared/model-typings/sbomrule';
import type { SBOMRule } from '../../shared/model-typings/sbomrule';

const hasComponentSupplier = (rule: SBOMRule) => {
  return rule.componentSupplier;
};

const hasAuthor = (rule: SBOMRule) => {
  return rule.author;
};

const hasCreationTimestamp = (rule: SBOMRule) => {
  return rule.creationTimestamp;
};

const hasComponentPurl = (rule: SBOMRule) => {
  return rule.componentPurl;
};

export const isValidMinCycloneDXVersion = (rule: SBOMRule) => {
  return rule.minCycloneDXVersion !== CycloneDXVersion.DENIED;
};

const hasCycloneDXRelationships = (rule: SBOMRule) => {
  return rule.cycloneDXRelationships;
};

export const isValidMinSPDXVersion = (rule: SBOMRule) => {
  return rule.minSPDXVersion !== SPDXVersion.DENIED;
};

const hasSPDXRelationships = (rule: SBOMRule) => {
  return rule.spdxRelationships;
};

export const isNTIAChecked = (rule: SBOMRule) => {
  return hasComponentSupplier(rule) &&
    hasAuthor(rule) &&
    hasCreationTimestamp(rule) &&
    hasComponentPurl(rule) &&
    isValidMinCycloneDXVersion(rule) &&
    hasCycloneDXRelationships(rule) &&
    isValidMinSPDXVersion(rule) &&
    hasSPDXRelationships(rule);
};
